/** 404 — matches prototype's clean styling. */
export function NotFound() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <p style={{ color: 'var(--text-2)' }}>Page not found.</p>
    </div>
  );
}